import * as React from 'react'
import FormGroup from '../installers_selector_app/form_group'

const { I18n } = window as any

type CreateLocationFormProps = {
  data: {
    name: string
    number: string
    address_attributes?: {
      line1?: string
      zip?: string
      city?: string
    }
    location_manager_id?: string
    location_manager_attributes?: {
      name?: string
      email?: string
      phones?: string
    }
  }
  setData: (data: any) => void
  formRef: React.RefObject<HTMLFormElement>
  canCreateLocationManager: boolean
  locationManagers: Array<{ label: string; value: number }>
}

function CreateLocationForm({
  data,
  setData,
  formRef,
  canCreateLocationManager,
  locationManagers,
}: CreateLocationFormProps) {
  const addressData = data.address_attributes || {}
  const locationManagerData = data.location_manager_attributes || {}
  const isCreatingNewManager = data.location_manager_id === 'create_new'

  const updateAddressField = (field: string, value: string) => {
    setData({
      ...data,
      address_attributes: {
        ...addressData,
        [field]: value,
      },
    })
  }

  const updateLocationManagerField = (field: string, value: string) => {
    setData({
      ...data,
      location_manager_attributes: {
        ...locationManagerData,
        [field]: value,
      },
    })
  }

  const handleLocationManagerChange = (value: string) => {
    const newData: any = {
      ...data,
      location_manager_id: value,
    }

    if (value !== 'create_new') {
      delete newData.location_manager_attributes
    }

    setData(newData)
  }

  return (
    <form className="default-form" action="#" method="POST" ref={formRef}>
      <ul>
        <FormGroup label={I18n.t('activerecord.attributes.location.name')} name="project_location_name">
          <input
            id="project_location_name"
            className="form-control"
            type="text"
            required
            name="name"
            value={data['name']}
            onChange={(e) =>
              setData({
                ...data,
                name: e.target.value,
              })
            }
          />
        </FormGroup>
        <FormGroup label={I18n.t('activerecord.attributes.location.number')} name="project_location_number">
          <input
            id="project_location_number"
            className="form-control"
            type="text"
            name="number"
            value={data['number']}
            onChange={(e) =>
              setData({
                ...data,
                number: e.target.value,
              })
            }
          />
        </FormGroup>
        <FormGroup label={I18n.t('activerecord.attributes.location.address')} name="project_location_line1">
          <input
            id="project_location_line1"
            className="form-control"
            type="text"
            name="line1"
            value={addressData.line1 || ''}
            onChange={(e) => updateAddressField('line1', e.target.value)}
          />
        </FormGroup>
        <FormGroup label={I18n.t('activerecord.attributes.address.zip')} name="project_location_zip">
          <input
            id="project_location_zip"
            className="form-control"
            type="text"
            name="zip"
            value={addressData.zip || ''}
            onChange={(e) => updateAddressField('zip', e.target.value)}
          />
        </FormGroup>
        <FormGroup label={I18n.t('activerecord.attributes.address.city')} name="project_location_city">
          <input
            id="project_location_city"
            className="form-control"
            type="text"
            name="city"
            value={addressData.city || ''}
            onChange={(e) => updateAddressField('city', e.target.value)}
          />
        </FormGroup>
        {canCreateLocationManager && (
          <>
            <FormGroup
              label={I18n.t('activerecord.attributes.location.location_manager')}
              name="project_location_manager"
            >
              <select
                id="project_location_manager"
                className="form-control"
                name="location_manager_id"
                value={data.location_manager_id || ''}
                onChange={(e) => handleLocationManagerChange(e.target.value)}
              >
                <option value=""></option>
                <option value="create_new">{I18n.t('campaigns.others.create_new_location_manager')}</option>
                {locationManagers.map((manager) => (
                  <option key={manager.value} value={manager.value}>
                    {manager.label}
                  </option>
                ))}
              </select>
            </FormGroup>

            {isCreatingNewManager && (
              <fieldset>
                <legend>{I18n.t('activerecord.models.users/location_manager.one')}</legend>
                <FormGroup
                  label={I18n.t('activerecord.attributes.users/base.name')}
                  name="project_location_manager_name"
                >
                  <input
                    id="project_location_manager_name"
                    className="form-control"
                    type="text"
                    required
                    name="location_manager_name"
                    value={locationManagerData.name || ''}
                    onChange={(e) => updateLocationManagerField('name', e.target.value)}
                  />
                </FormGroup>
                <FormGroup
                  label={I18n.t('activerecord.attributes.users/base.email')}
                  name="project_location_manager_email"
                >
                  <input
                    id="project_location_manager_email"
                    className="form-control"
                    type="email"
                    required
                    name="location_manager_email"
                    value={locationManagerData.email || ''}
                    onChange={(e) => updateLocationManagerField('email', e.target.value)}
                  />
                </FormGroup>
                <FormGroup
                  label={I18n.t('activerecord.attributes.users/base.phones')}
                  name="project_location_manager_phones"
                >
                  <input
                    id="project_location_manager_phones"
                    className="form-control"
                    type="text"
                    required
                    name="location_manager_phones"
                    value={locationManagerData.phones || ''}
                    onChange={(e) => updateLocationManagerField('phones', e.target.value)}
                  />
                </FormGroup>
              </fieldset>
            )}
          </>
        )}
      </ul>
    </form>
  )
}

export default CreateLocationForm
